import { render } from "./ElementGroupHeader.vue?vue&type=template&id=7fc5722b"
import script from "./ElementGroupHeader.vue?vue&type=script&lang=js"
export * from "./ElementGroupHeader.vue?vue&type=script&lang=js"

import "./ElementGroupHeader.vue?vue&type=style&index=0&id=7fc5722b&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__